/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-no-useless-fragment */
import React from "react";
import { Empty } from "antd";
import { LoadingOutlined } from "@ant-design/icons";

export const fullScreen = {
    width: "100%",
    height: "100%",
    display: "flex",
    flexFlow: "column",
    alignItems: "center",
    justifyContent: "center"
};

const defaultProps = {
    show: true,
    isFullscreen: false,
    emptyProps: {
        description: "No Data",
        extra: null
    },
    loadingProps: {
        image: <LoadingOutlined style={{
            fontSize: "90px",
            color: "var(--blue-500)"
        }}
        />,
        loading: false,
        loadingText: "Loading...",
        extra: null
    }
};
function RenderComponent(props) {
    const { children } = props;
    const componentProps = { ...props };

    componentProps.loadingProps = {
        ...defaultProps.loadingProps,
        ...props.loadingProps || {}
    };
    componentProps.emptyProps = {
        ...defaultProps.emptyProps,
        ...props.emptyProps || {}
    };

    const isLoading = componentProps.loadingProps.loading;
    const displayEmpty = componentProps.show || isLoading;

    const {
        finalProps,
        extra
    } = (() => {
        const tempObj = isLoading ? componentProps.loadingProps : componentProps.emptyProps;
        const emptyChildren = tempObj.extra;

        if (componentProps.isFullscreen) {
            tempObj.style = {
                ...tempObj.style || {},
                ...fullScreen
            };
        }
        delete tempObj.extra;
        delete tempObj.loading;
        if (tempObj.loadingText) {
            tempObj.description = tempObj.loadingText
        }

        return {
            finalProps: tempObj,
            extra: emptyChildren
        };
    })();

    return (
        <>
            {displayEmpty ? (
                <Empty {...finalProps}>
                    {extra}
                </Empty>
            ) : children}
        </>
    );
}

export default RenderComponent;
